// extracted by mini-css-extract-plugin
module.exports = {"icon":"Help_icon__3wGUf"};